import React, {FC} from 'react';
import {SeverCustomerAuthTokenProvider} from './SeverCustomerAuthTokenProvider';
import {BasketTokenProvider} from './basketStore/BasketTokenProvider';
import {MinimalStateProvider} from './basketStore/useBasketMinimalState';
import {CustomerProvider} from './customer/customer.hooks';
import {CustomerSessionValidProvider} from './customerSessionValidStore/customerSessionValidStore.hook';
import {SessionProvider} from './sessionStore/session.hooks';
import {UserProvider} from './userStore/user.hooks';
import {WishlistStateProvider} from './wishlistStore/useWishlistState';

export const UserStateProvider: FC<
  React.PropsWithChildren<{
    UserSelectedDiscountProvider: FC<React.PropsWithChildren>;
    authToken?: string;
  }>
> = ({children, UserSelectedDiscountProvider, authToken}) => {
  return (
    <SeverCustomerAuthTokenProvider authToken={authToken}>
      <SessionProvider>
        <UserProvider>
          <CustomerProvider>
            <UserSelectedDiscountProvider>
              <WishlistStateProvider>
                <CustomerSessionValidProvider>
                  <BasketTokenProvider>
                    <MinimalStateProvider>{children}</MinimalStateProvider>
                  </BasketTokenProvider>
                </CustomerSessionValidProvider>
              </WishlistStateProvider>
            </UserSelectedDiscountProvider>
          </CustomerProvider>
        </UserProvider>
      </SessionProvider>
    </SeverCustomerAuthTokenProvider>
  );
};
